import React from 'react';
import { DatabaseIcon, MessageSquareWarningIcon, CheckCircleIcon, FileJsonIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const WhyItWorks = () => {
  const reasons = [{
    icon: <DatabaseIcon className="text-orange-500" size={24} data-id="element-470" />,
    title: 'Schema-first',
    description: 'Your data model is the source of truth.'
  }, {
    icon: <MessageSquareWarningIcon className="text-orange-500" size={24} data-id="element-471" />,
    title: 'Validation + follow-ups',
    description: 'Catch issues before submission.'
  }, {
    icon: <CheckCircleIcon className="text-orange-500" size={24} data-id="element-472" />,
    title: 'Confirmations when it matters',
    description: 'Reduce mistakes on critical fields.'
  }, {
    icon: <FileJsonIcon className="text-orange-500" size={24} data-id="element-473" />,
    title: 'Deterministic output',
    description: 'Clean JSON aligned to your schema.'
  }];
  return <section className="w-full bg-gray-50 py-12 sm:py-16 md:py-20 lg:py-[4.75rem] border-y border-gray-200" data-id="element-474">
      <div className="container mx-auto px-4" data-id="element-475">
        <div className="max-w-4xl mx-auto" data-id="element-476">
          <div className="text-center mb-10 sm:mb-12" data-id="element-477">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 px-2" data-id="element-478">
              Built by builders who've shipped products used by millions.
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed px-2" data-id="element-479">
              We make AI solutions easy to embed — even for non-technical teams.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6" data-id="element-480">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-5 sm:p-6 rounded-xl border border-gray-200 shadow-sm flex items-start gap-3 sm:gap-4" data-id="element-481">
                <div className="bg-orange-50 p-2.5 sm:p-3 rounded-lg shrink-0" data-id="element-482">
                  {reason.icon}
                </div>
                <div data-id="element-483">
                  <h3 className="font-bold text-gray-900 mb-1 text-base sm:text-lg" data-id="element-484">
                    {reason.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base" data-id="element-485">
                    {reason.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default WhyItWorks;